'use client';

import React from 'react';
import { SignInPage } from '../sign-in-page';
import { ContentWrapper } from '../../ui/content-wrapper';
import Navigation from '../navigation';
import { LicensesTable } from './licenses-table';
import { accountCard, headerStyles } from '@/lib/shared/styles/account';
import { SessionWrapper } from '../../ui/session-wrapper';

export const LicensesPage = () => {
  return (
    <SessionWrapper loggedOutContent={<SignInPage />}>
      <ContentWrapper className={headerStyles}>
        <Navigation activeLink="licenses" />
        <div className={accountCard}>
          <LicensesTable />
        </div>
      </ContentWrapper>
    </SessionWrapper>
  );
};
